import { routeName } from '@/constants/routeName';
import StoreList from '@/views/StoreManagement/StoreList/index.vue';
import StoreManagementWorkerFeePerStoreGroupSetting from '@/views/StoreManagement/WorkerFeePerStoreGroupSetting/index.vue';
import StoreManagementCreate from '@/views/StoreManagement/StoreCreate/index.vue';
import StoreManagementDetailDetail from '@/views/StoreManagement/StoreDetail/index.vue';
import StoreManagementDetailEdit from '@/views/StoreManagement/StoreEdit/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'store-management',
        name: routeName.STORE_MANAGEMENT,
        component: StoreList,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'store-management/worker-fee-per-store-group-setting',
        name: routeName.STORE_MANAGEMENT_WORKER_FEE_PER_STORE_GROUP_SETTING,
        component: StoreManagementWorkerFeePerStoreGroupSetting,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'store-management/create',
        name: routeName.STORE_MANAGEMENT_CREATE,
        component: StoreManagementCreate,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'store-management/:storeId',
        redirect: {
            name: routeName.STORE_MANAGEMENT_DETAIL,
        },
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'store-management/:storeId/detail',
        name: routeName.STORE_MANAGEMENT_DETAIL,
        component: StoreManagementDetailDetail,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'store-management/:storeId/:pageType(basic-info|management-fee|reception-operation)',
        name: routeName.STORE_MANAGEMENT_EDIT,
        component: StoreManagementDetailEdit,
        meta: {
            ...basicOptions,
        },
    },
];
